<template>
  <div class="account-list-box">
    <div class="account-list-tab">
      <a-tabs
        v-model="activeName"
        :animated="false"
        @change="handleClick"
      >
        <a-tab-pane
          key="accountInfo"
          :tab="accountTit"
        >
          <!-- <account-info
            v-if="page === 'accountInfo'"
          /> -->
        </a-tab-pane>
        <a-tab-pane
          key="loginLog"
          :tab="loginLogTit"
        >
          <!-- <log v-if="page === 'loginLog'" /> -->
        </a-tab-pane>
        <a-tab-pane
          key="orderList"
          :tab="orderRecordTit"
        >
          <!-- <order v-if="page === 'orderList'" /> -->
        </a-tab-pane>
        <a-tab-pane
          key="invoice"
          :tab="voiveManageTit"
        >
          <!-- <invoice v-if="page === 'invoice'" /> -->
        </a-tab-pane>
        <a-tab-pane
          key="mailList"
          :tab="$t('message[1885]')"
        >
          <!-- <mail-list v-if="page === 'mailList'" /> -->
        </a-tab-pane>
      </a-tabs>
      <router-view />
    </div>
  </div>
</template>
<script>
/* import AccountInfo from './AccountInfo'
import Order from './Order'
import Invoice from './Invoice'
import Log from './Log'
import MailList from './StationMail' */
export default {
  name: 'ManageList',
  /* components: {
    AccountInfo,
    Order,
    Invoice,
    Log,
    MailList
  }, */
  /* props: {
    page: {
      type: String,
      default: ''
      // required: true
    }
  }, */
  data () {
    return {
      activeName: '',
      LinkPath: '',
      title: ''
    }
  },
  computed: {
    queryData () {
      return this.$route.query
    },
    routerName () {
      return this.$route.name
    },
    loginLogTit () {
      return this.$t('message["199"]')
    },
    orderRecordTit () {
      return this.$t('message["246"]')
    },
    voiveManageTit () {
      return this.$t('message["268"]')
    },
    accountTit () {
      return this.$t('message["1571"]')
    }
  },
  watch: {
    /* page (val) {
      this.activeName = val === 'qwdd' ? 'qwdd' : 'person'
    } */
    routerName (val) {
      if (!val) return
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      switch (this.routerName) {
        case 'AccountInfo':
          this.activeName = 'accountInfo'
          this.title = this.$t('message["1571"]')
          break
        case 'AccountLoginLog':
          this.activeName = 'loginLog'
          this.title = this.$t('message["199"]')
          break
        case 'AccountOrder' :
          this.activeName = 'orderList'
          this.title = this.$t('message["246"]')
          break
        case 'AccountInvoice' :
          this.activeName = 'invoice'
          this.title = this.$t('message["268"]')
          break
        case 'AccountMailList' :
          this.activeName = 'mailList'
          this.title = this.$t('message["1885"]')
          break
      }
      document.title = this.title + '-' + this.$t('message["1381"]')
    },
    handleClick (tab, event) {
      // console.log(event)
      // this.queryData.type = this.activeName
      // this.page = this.activeName
      switch (this.activeName) {
        case 'accountInfo':
          this.LinkPath = '/account/accountinfo'
          this.title = this.$t('message["1571"]')
          break
        case 'loginLog':
          this.LinkPath = '/account/loginlog'
          this.title = this.$t('message["199"]')
          break
        case 'orderList' :
          this.LinkPath = '/account/order'
          this.title = this.$t('message["246"]')
          break
        case 'invoice' :
          this.LinkPath = '/account/invoice'
          this.title = this.$t('message["268"]')
          break
        case 'mailList' :
          this.LinkPath = '/account/maillist'
          this.title = this.$t('message["1885"]')
          break
      }
      document.title = this.title + '-' + this.$t('message["1381"]')
      if (this.LinkPath) {
        this.$router.push({
          path: this.LinkPath
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .account-list-box::v-deep {
    padding: 40px;
    .ant-tabs-tab {
      font-size: 18px;
    }
  }
</style>
